import { v4 as uuidv4 } from 'uuid';

function setWhatshotEnabled(enabled) {
    this.search.whatshotEnabled = enabled;
    this.observed.search = uuidv4();
}

export default setWhatshotEnabled;
